import { createSlice } from '@reduxjs/toolkit';

// Константы с наборами тем
export const THEME_SETS = {
  'default': {
    id: 'default',
    name: 'Default theme box',
    light: {
      bg: 'c-light-gray',
      bgActive: 'c-blue',
      border: 'c-blue',
      shadow: '',
      borderActive: 'c-yellow',
      hover: 'c-dark-blue',
      color: 'c-blue',
      colorActive: 'c-white'
    },
    dark: {
      bg: 'c-light-black',
      bgActive: 'c-gray',
      border: 'c-gray',
      shadow: '',
      borderActive: 'c-yellow',
      hover: 'c-light-gray',
      color: 'c-gray',
      colorActive: 'c-black'
    }
  },
  'green': {
    id: 'green',
    name: 'Green theme box',
    light: {
      bg: 'c-light-green',
      bgActive: 'c-green',
      border: 'c-dark-green',
      shadow: '',
      borderActive: 'c-green',
      hover: 'c-medium-green',
      color: 'c-dark-green',
      colorActive: 'c-dark-green'
    },
    dark: {
      bg: 'c-dark-green',
      bgActive: 'c-medium-green',
      border: 'c-medium-green',
      shadow: '',
      borderActive: 'c-green',
      hover: 'c-light-green',
      color: 'c-medium-green',
      colorActive: 'c-dark-green'
    }
  }
};

// Функции для работы с localStorage
const loadThemeFromStorage = () => {
  try {
    const savedTheme = localStorage.getItem('selectedTheme');
    const savedDarkMode = localStorage.getItem('darkMode');
    
    if (savedTheme) {
      const themeData = JSON.parse(savedTheme);
      // Находим тему по ID в константах
      return Object.values(THEME_SETS).find(theme => theme.id === themeData.id) || THEME_SETS.default;
    }
  } catch (error) {
    console.error('Error loading theme from localStorage:', error);
  }
  return THEME_SETS.default;
};

const loadDarkModeFromStorage = () => {
  try {
    // Та же логика, что в инлайн-скрипте index.html: выбор пользователя из 'theme',
    // 'auto'/отсутствие значения → системная тема; 'darkMode' — легаси-ключ
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') return true;
    if (savedTheme === 'light') return false;
    if (savedTheme === 'auto') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    const savedDarkMode = localStorage.getItem('darkMode');
    if (savedDarkMode !== null) return JSON.parse(savedDarkMode);
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  } catch (error) {
    console.error('Error loading dark mode from localStorage:', error);
  }
  return false;
};

const saveThemeToStorage = (theme: any) => {
  try {
    localStorage.setItem('selectedTheme', JSON.stringify({
      id: theme.id,
      name: theme.name
    }));
  } catch (error) {
    console.error('Error saving theme to localStorage:', error);
  }
};

const saveDarkModeToStorage = (isDarkMode: boolean) => {
  try {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
  } catch (error) {
    console.error('Error saving dark mode to localStorage:', error);
  }
};

const initialState = {
  currentThemeSet: loadThemeFromStorage(),
  isDarkMode: loadDarkModeFromStorage()
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeSet: (state, action) => {
      state.currentThemeSet = action.payload;
      saveThemeToStorage(action.payload);
    },
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode;
      saveDarkModeToStorage(state.isDarkMode);
    },
    setDarkMode: (state, action) => {
      state.isDarkMode = action.payload;
      saveDarkModeToStorage(action.payload);
    },
    resetTheme: (state) => {
      state.currentThemeSet = THEME_SETS.default;
      state.isDarkMode = false;
      saveThemeToStorage(THEME_SETS.default);
      saveDarkModeToStorage(false);
    }
  }
});

export const { setThemeSet, toggleDarkMode, setDarkMode, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;
